import { formErrorAnatomy as o } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers as t, cssVar as l, defineStyle as r } from "@chakra-ui/styled-system";
const { definePartsStyle: n, defineMultiStyleConfig: a } = t(o.keys), e = l("form-error-color"), i = r({
  mt: "1",
  fontSize: "sm",
  fontWeight: "regular",
  letterSpacing: "normal",
  lineHeight: "5",
  alignItems: "start",
  [e.variable]: "colors.red.500",
  _dark: {
    [e.variable]: "colors.red.300"
  },
  color: e.reference
}), s = r({
  minH: "5",
  // w: 'icon.sm',
  // h: 'icon.sm',
  w: "1em",
  h: "1em",
  marginEnd: "0.5em",
  [e.variable]: "colors.red.500",
  _dark: {
    [e.variable]: "colors.red.300"
  },
  color: e.reference
}), c = n({
  text: i,
  icon: s
}), d = a({
  baseStyle: c
});
export {
  d as formErrorTheme
};
